import { render, staticRenderFns } from "./LiveModeCourseCpnt.vue?vue&type=template&id=6c350492&scoped=true&"
import script from "@/scripts/MainMode/MainModeCourse/MainModeCourseCpnt/LiveModeCpnt/index.js?vue&type=script&lang=js&"
export * from "@/scripts/MainMode/MainModeCourse/MainModeCourseCpnt/LiveModeCpnt/index.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c350492",
  null
  
)

export default component.exports